<template>
  <div v-if="user" class="user">
    <div class="photo">
      <avatar :name="user.getLastName()"
              :upic="user.getUpic()"
              size="ic">
      </avatar>
    </div>
    <div class="info">
      <a data-toggle="collapse" @click="toggleMenu" href="javascript:void(0)">
           <span class="name">
             <span>{{ user.getFullName() }}</span>
             <b
              class="caret"
              :class="{'caret--opened': !isClosed}"
             />
          </span>
      </a>
      <div class="clearfix"></div>
      <div>
        <el-collapse-transition>
          <ul class="nav" v-show="!isClosed">
            <li>
              <router-link :to="{ name: 'profilePage'}" @click.native="closeSidebar">
                <span class="sidebar-mini">{{ $t('common.dropdown_menu.my_profile_short') }}</span>
                <span class="sidebar-normal">{{ $t('common.dropdown_menu.my_profile') }}</span>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: editLink, params: { id: user.getId() }}"  @click.native="closeSidebar">
                <span class="sidebar-mini">{{ $t('common.dropdown_menu.edit_profile_short') }}</span>
                <span class="sidebar-normal">{{ $t('common.dropdown_menu.edit_profile') }}</span>
              </router-link>
            </li>
            <li>
              <a href="#" @click.prevent="logout();closeSidebar()">
                <span class="sidebar-mini">{{ $t('common.dropdown_menu.logout_short') }}</span>
                <span class="sidebar-normal">{{ $t('common.dropdown_menu.logout') }}</span>
              </a>
            </li>
          </ul>
        </el-collapse-transition>
      </div>
    </div>
  </div>
</template>
<script>
  import ElCollapseTransition from 'element-ui/lib/transitions/collapse-transition';
  import auth from 'src/services/auth';
  import avatar from 'src/components/Avatar/avatar.vue'
  import {USER_ROLE_ADMIN} from '@/constants'

  export default {
    props: [
      'user'
    ],
    components: {
      ElCollapseTransition,
      avatar
    },
    data () {
      return {
        isClosed: true
      }
    },
    methods: {
      closeSidebar () {
        this.$store.commit('sidebarOpened', false)
      },
      toggleMenu () {
        this.isClosed = !this.isClosed
      },
      async logout () {
        this.$store.dispatch('user/logout').then(() => {
          this.$router.push('/login')
        }).catch(() => {
          this.$router.push('/login')
        }).finally(() => {
          localStorageTransport.emit('logout', true)
        })
      }
    },
    computed: {
      editLink: self => {
        if (self.isAdmin) {
          return 'userEdit'
        } else {
          return 'profileEdit'
        }
      },
      isAdmin () {
        return this.user.checkRole(USER_ROLE_ADMIN)
      }
    }
  }
</script>
<style>
  .collapsed {
    transition: opacity 1s;
  }
</style>